import T from "./T";

const employersTableHeader = (isManager : boolean) => {
    const {
        COMPANY,
        EMPLOYEE_NAME,
        EMAIL,
        ROLE,
        REGISTRATION_DATE,
        ACTION,
    } = T;


    const tableFields = [
        { label: COMPANY  },
        { label: EMPLOYEE_NAME },
        { label: EMAIL },
        { label: ROLE },
        { label: REGISTRATION_DATE },
    ];

    if (!isManager) tableFields.push({ label: ACTION });

    return tableFields;
};

export default employersTableHeader;
